export default __webpack_public_path__ + "static/monika_barcikowska-468ad93d1e7f374d4e8c053b55a747ce.jpg";